import { type PermissionApiModel } from '@webapp/platform/iam/data-access/api-models/PermissionApiModel'
import { type PermissionConstructor } from '@webapp/platform/iam/entities/Permission'
import { mapTierApiModelToEnum } from './mapTierApiModelToEnum'

export const mapPermissionApiModel = (
  permission: PermissionApiModel
): PermissionConstructor => {
  return {
    id: permission.id,
    key: permission.codename,
    tier: mapTierApiModelToEnum(permission.tier),
  }
}
